import { cn } from '@/lib/utils';

interface BasketballLoaderProps {
  className?: string;
  size?: number;
}

const BasketballLoader = ({ className, size = 28 }: BasketballLoaderProps) => (
  <div className={cn('flex items-center justify-center', className)}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className="animate-[spin_1.2s_cubic-bezier(0.4,0,0.2,1)_infinite] text-primary"
    >
      {/* Ball fill */}
      <circle cx="12" cy="12" r="10" fill="hsl(var(--primary))" opacity="0.15" />
      {/* Outer circle */}
      <circle cx="12" cy="12" r="10" stroke="hsl(var(--primary))" strokeWidth="1.8" />
      {/* Vertical seam */}
      <path d="M12 2v20" stroke="hsl(var(--foreground))" strokeWidth="1.2" opacity="0.7" />
      {/* Horizontal seam */}
      <path d="M2 12h20" stroke="hsl(var(--foreground))" strokeWidth="1.2" opacity="0.7" />
      {/* Left curve */}
      <path d="M5.2 5.2c2.6 2.6 2.6 11 0 13.6" stroke="hsl(var(--foreground))" strokeWidth="1.2" opacity="0.7" />
      {/* Right curve */}
      <path d="M18.8 5.2c-2.6 2.6-2.6 11 0 13.6" stroke="hsl(var(--foreground))" strokeWidth="1.2" opacity="0.7" />
    </svg>
  </div>
);

export default BasketballLoader;
